import { createFilter } from "react-select";

// Fixes the overlapping problem of the component
export const zIndexFix = {
  menu: provided => ({ ...provided, zIndex: 9 })
};

export const countryFilterOption = (option, inputValue) => {
  const input = inputValue.toLowerCase();
  const value = option.value.toLowerCase(); // country code
  const name = option.data.name.toLowerCase(); // country name
  // Match "fi" or "suomi" first (remove sudan, fidji etc.)
  return (value.startsWith(input) || (!value.startsWith("sd") && !name.startsWith("fi") && name.startsWith(input)));
};

export const obsoleteOptionStyle = (provided, state) => ({
  ...provided,
  opacity: state.data.isObsolete ? 0.5 : 1,
});

export const reactSelectSearchSettings = t => ({
  placeholder: t("SearchOrSelect", "Etsi tai valitse"),
  noOptionsMessage: () => t("NoOptions", "Ei valintoja"),
  //menuPlacement: "auto",
  styles: { menuPortal: provided => ({ ...provided, zIndex: 2 }) }, // zIndexFix
  menuPosition: "fixed",
  filterOption: createFilter({ ignoreAccents: false }),
});

export const reactSelectPersonSettings = t => ({
  placeholder: t("SelectPerson", "Valitse henkilö"),
  noOptionsMessage: () => t("NoOptions", "Ei valintoja"),
  styles: { menuPortal: provided => ({ ...provided, zIndex: 2 }) }, // zIndexFix
  menuPosition: "fixed",
  filterOption: createFilter({
    ignoreAccents: false,
    stringify: option => option.data.numberName,
  }),
});

export const asyncSelectSearchSettings = t => {
  const msg = t("SearchByName", "Haku nimellä");
  const msgFunc = () => msg;
  return {
    placeholder: msg,
    noOptionsMessage: msgFunc,
    loadingMessage: msgFunc,
    //menuPlacement: "auto",
    cacheOptions: true,
    menuPosition: "fixed",
    filterOption: createFilter({ ignoreAccents: false }),
    styles: { menuPortal: provided => ({ ...provided, zIndex: 2 }) }, // zIndexFix
  };
};

export const creatableSelectCodeSettings = t => ({
  placeholder: t("SelectOrAdd", "Valitse tai lisää"),
  formatCreateLabel: input => `${t("Create", "Luo")} "${input}"`,
  noOptionsMessage: () => t("NoOptions", "Ei valintoja"),
  //menuPlacement: "auto",
  menuPosition: "fixed",
  styles: { menuPortal: provided => ({ ...provided, zIndex: 2 }) }, // zIndexFix
  filterOption: createFilter({ ignoreAccents: false }),
});

export const creatableSelectTagSettings = t => ({
  placeholder: t("Keywords", "Avainsanat"),
  formatCreateLabel: input => `${t("Create", "Luo")} "${input}"`,
  noOptionsMessage: () => t("NoOptions", "Ei valintoja"),
  isMulti: true,
  //menuPlacement: "auto",
  menuPosition: "fixed",
  styles: { menuPortal: provided => ({ ...provided, zIndex: 2 }) }, // zIndexFix
  filterOption: createFilter({ ignoreAccents: false }),
});
